import { IconCreditCard, IconPlus } from '@tabler/icons';
const icons = {
    IconCreditCard, IconPlus
};

// ==============================|| Contract MENU ITEMS ||============================== //

const Contract = {
    id: 'contract',
    title: 'Contract',
    caption: '',
    type: 'group',
    children: [
        {
            id: 'manage',
            title: 'Manage Contract',
            type: 'item',
            icon: icons.IconCreditCard,
            url: '/contract',
            breadcrumbs: false
        },
        {
            id: 'open',
            title: 'Open Contract',
            type: 'item',
            url: '/contract/new',
            icon: icons.IconPlus,
            breadcrumbs: false
        },
    ]
};

export default Contract;
